import jsf from 'json-schema-faker';
import { Validator } from 'jsonschema';

jsf.option({
  useDefaultValue: true,
  fillProperties: false,
  alwaysFakeOptionals: true,
});

const validate = (object, schema) => {
  const validator = new Validator();
  return validator.validate(object, schema);
}

const ensureAtPath = (obj, path) => path.reduce((o, k) => (o[k] ??= {}), obj);
const getSchemaAtPath = (sch, path) => path.reduce((s, k) => (s && s.properties ? s.properties[k] : undefined), sch) || sch;

const cleanObject = (instance, schema, errors) => {
  const data = JSON.parse(JSON.stringify(instance));
  errors.forEach(err => {
    const p = Array.isArray(err.path) ? err.path : [];
    if (err.name === 'additionalProperties') {
      const parent = ensureAtPath(data, p);
      delete parent[err.argument];
    }
    if (err.name === 'required') {
      const targetSchema = getSchemaAtPath(schema, p);
      const parent = ensureAtPath(data, p);
      parent[err.argument] = targetSchema.properties?.[err.argument]?.default ?? null;
    }
    if (err.name === 'enum' || err.name === 'type') {
      const key = p[p.length - 1];
      const parentPath = p.slice(0, -1);
      const parent = ensureAtPath(data, parentPath);
      const targetSchema = getSchemaAtPath(schema, parentPath);
      parent[key] = targetSchema.properties?.[key]?.default ?? null;
    }
  });
  return data;
};

export const createDefaults = (schema, allSchemas) => {
  return jsf.generate(schema || {}, allSchemas);
}

export const cleanObjectWithSchema = (instance, schema) => {
  const result = validate(instance, schema);
  return cleanObject(instance, schema, result.errors)
}